var map = {
	"./en-au": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-au.js",
	"./en-gb": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-gb.js",
	"./zh-cn": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-cn.js",
	"./zh-tw": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-tw.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/en-au": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-au.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/en-au.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-au.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/en-gb": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-gb.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/en-gb.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/en-gb.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/zh-cn": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-cn.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/zh-cn.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-cn.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/zh-tw": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-tw.js",
	".pnpm/moment@2.29.4/node_modules/moment/locale/zh-tw.js": "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/.pnpm/moment@2.29.4/node_modules/moment/locale sync recursive en-au%7Cen-gb%7Czh-cn%7Czh-tw";